var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBrightness24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.003,
    height: 16.003,
    viewBox: "0 0 16.003 16.003",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_brightness24x24",
    transform: "translate(-2 -2)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M11,2.88V4.32a.876.876,0,0,0,.8.88.822.822,0,0,0,.8-.88V2.88A.822.822,0,0,0,11.8,2,.876.876,0,0,0,11,2.88Z",
    transform: "translate(-1.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M11,18.88v1.44a.8.8,0,1,0,1.6,0V18.88a.822.822,0,0,0-.8-.88A.876.876,0,0,0,11,18.88Z",
    transform: "translate(-1.799 -3.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M15,10.68a4.013,4.013,0,1,1-8,.64A4.071,4.071,0,0,1,10.678,7H11A3.843,3.843,0,0,1,15,10.68Z",
    transform: "translate(-.997 -.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M4.929,6.049l1.04,1.04a.967.967,0,0,0,1.2.08.807.807,0,0,0-.08-1.2l-1.04-1.04a.875.875,0,0,0-1.2-.08A.875.875,0,0,0,4.929,6.049Z",
    transform: "translate(-.529 -.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M16.237,17.357l1.04,1.04a.967.967,0,0,0,1.2.08.807.807,0,0,0-.08-1.2l-1.04-1.04a.967.967,0,0,0-1.2-.08A.967.967,0,0,0,16.237,17.357Z",
    transform: "translate(-2.795 -2.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M17.277,4.929l-1.04,1.04a.967.967,0,0,0-.08,1.2.807.807,0,0,0,1.2-.08l1.04-1.04a.967.967,0,0,0,.08-1.2A.875.875,0,0,0,17.277,4.929Z",
    transform: "translate(-2.795 -.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M5.977,16.237l-1.04,1.04a.967.967,0,0,0-.08,1.2.807.807,0,0,0,1.2-.08l1.04-1.04a.967.967,0,0,0,.08-1.2A.967.967,0,0,0,5.977,16.237Z",
    transform: "translate(-.537 -2.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M20.32,11H18.88a.8.8,0,1,0,0,1.6h1.44a.8.8,0,1,0,0-1.6Z",
    transform: "translate(-3.198 -1.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M4.32,11H2.88a.8.8,0,1,0,0,1.6H4.32a.8.8,0,1,0,0-1.6Z",
    transform: "translate(0 -1.799)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBrightness24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_brightness24x24.214d1bd4f46e6b1058812f2672ee7808.svg";